// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./ss2025-feature.css";

// *************************** Import Images *************************** //

// ** Icons ** //
// import "/src/assets/icons/purple-play-button.png";

// ** Video Thumbnails ** //
// import "/src/assets/spring-sessions-2025/this-is-fred.png";
// import "/src/assets/spring-sessions-2025/and-we-code.webp";
// import "/src/assets/spring-sessions-2025/hello.webp";
// import "/src/assets/spring-sessions-2025/code-with-us.webp";
// import "/src/assets/spring-sessions-2025/be-yourself.webp";
// import "/src/assets/spring-sessions-2025/be-rainbow.webp";
// import "/src/assets/spring-sessions-2025/reach-for-skies.webp";
// import "/src/assets/spring-sessions-2025/just-live.webp";
// import "/src/assets/spring-sessions-2025/kindness.webp";

// ** LOPL Logo ** //
// import "/src/assets/sponsor-logos/LOPL/lopl-full-round-logo-2026.png";


// *********************** Native Video Modal Lightbox Engine *********************** //
document.addEventListener('DOMContentLoaded', () => {
  
  // 1. Initialize Functional Shared Pure Text Toggles Safely
  initTextLinkToggle('ss25-read-more', 'ss25-read-more-closed', 'Read More', 'Close');
  initTextLinkToggle('ss25-read-credits', 'ss25-read-credits-closed', 'See Video Credits', 'Close Video Credits');

  // 2. Lightbox Selectors Mapping Pipeline
  const lightboxContainer = document.getElementById("ss2025-video-popout");
  const embeddedPlayer = lightboxContainer ? lightboxContainer.querySelector(".ss2025-videoPlayer") : null;
  const lightboxCloseBtn = lightboxContainer ? lightboxContainer.querySelector(".ss2025-close-btn") : null;

  const messageElement = document.getElementById('videoMessage');
  
  const silentVideos = [
    'ss25-charlotte-be-rainbow.mp4',
    'ss25-colbie-reach-for-skies.mp4',
    'ss25-erie-just-live-enjoy-it-2.mp4',
    'ss25-charley-kindness-can-go-far-2.mp4',
    'ss25-kenyah-be-yourself.mp4'
  ];

  function updateSilentMessage(currentSrc) {
    // Extract just the filename from the absolute URL path
    const filename = currentSrc.split('/').pop();

    // console.log("Filename: ", filename);

    if (silentVideos.includes(filename)) {
      messageElement.textContent = "Note: This is a silent video.";
      messageElement.style.display = "block";
    } else {
      messageElement.textContent = "";
      messageElement.style.display = "none";
    }
  }

  if (lightboxContainer && embeddedPlayer && lightboxCloseBtn) {
    
    // Unified play invocation track function
    const triggerVideoPlayback = (videoUrl) => {
      if (!videoUrl) return;
      if (document.pictureInPictureElement == null) {
        lightboxContainer.style.display = "flex";
      }

      embeddedPlayer.src = videoUrl;

      // console.log("Current video src: ", embeddedPlayer.src);

      updateSilentMessage(embeddedPlayer.src);

      embeddedPlayer.play().catch(err => console.log("Playback interaction deferred safely: ", err));

    };

    // Consolidated loops binding all thumbnails and text credits via single logic track
    document.querySelectorAll('.video-card, .video-credit').forEach(triggerItem => {
      if (triggerItem) {
        triggerItem.addEventListener('click', function(e) {
          e.preventDefault();
          const targetUrl = this.getAttribute('data-video-url');
          if (targetUrl) triggerVideoPlayback(targetUrl);
        });
      }
    });

    // Close Lightbox Cleanups Lifecycle Path
    const exitLightboxPlayback = () => {
      lightboxContainer.style.display = "none";
      embeddedPlayer.pause();
      embeddedPlayer.src = ""; // Flushes buffer tracks
    };

    lightboxCloseBtn.addEventListener("click", exitLightboxPlayback);

    lightboxContainer.addEventListener('click', (event) => {
      if (event.target === lightboxContainer) exitLightboxPlayback();
    });

    // Handle Picture-In-Picture lifecycle steps cleanly
    embeddedPlayer.addEventListener("enterpictureinpicture", () => {
      lightboxContainer.style.display = "none";
    });

    embeddedPlayer.addEventListener("leavepictureinpicture", () => {
      lightboxContainer.style.add("active");
    });
  }

  updateSilentMessage(embeddedPlayer.src );
});


// *********************** JS For "Read More" links ***********************//

function initTextLinkToggle(checkboxId, labelId, regularText, expandedText) {
  const toggleInput = document.getElementById(checkboxId);
  const targetLabel = document.getElementById(labelId);

  if (toggleInput && targetLabel) {
    const descriptiveSpan = targetLabel.querySelector('.read-more-text');
    const visualIconNode = targetLabel.querySelector('.bi');

    toggleInput.addEventListener('change', function() {
      if (this.checked) {
        if (descriptiveSpan) descriptiveSpan.textContent = expandedText;
        if (visualIconNode) visualIconNode.className = 'read-more-arrow bi bi-arrow-up-circle-fill ms-2 h5 mb-0';
      } else {
        if (descriptiveSpan) descriptiveSpan.textContent = regularText;
        if (visualIconNode) visualIconNode.className = 'read-more-arrow bi bi-arrow-right-circle-fill ms-2 h5 mb-0';
      }
    });
  }
}



